import React, { useState } from "react";

const SidebarSubscribe = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false); // For loading state
  const [message, setMessage] = useState(""); // To display success/error message

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(""); // Reset message on new submission

    try {
      // Simulating API request
      const response = await fetch("/api/newsletter", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }), // Send email to the backend
      });

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage("Subscription successful!");
        setMessage("Thank you for subscribing!"); // Success message
        setEmail("");
      } else {
        setErrorMessage(data.message || "Something went wrong. Please try again.");
        setMessage("There was an error with your subscription."); // Error message
      }
    } catch (error) {
      setMessage("An error occurred. Please try again.");
    } finally {
      setLoading(false);
      setIsSubmitting(false);
    }
  };

  return (
    <div className="sidebar-subscribe bg-white p-4 rounded-md max-w-lg mx-auto border">
      <h5 className="sidebar-title text-md font-semibold text-gray-700 mb-2 border-b">
        Subscribe to the weekly blog newsletter
      </h5>
      <div className="mc_embed_signup">
        <p className="text-sm text-gray-500 mb-4">
          Get the latest in privacy news, tips, tricks, and security guides to
          level-up your digital security.
        </p>

        {/* New form structure */}
        <form onSubmit={handleSubmit} className="w-full space-y-4">
          <div className="border border-gray-100 p-2 focus-within:ring sm:flex sm:items-center sm:gap-4">
            <input
              type="email"
              id="UserEmail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="w-full border-none focus:border-transparent focus:ring-transparent sm:text-sm"
              required
            />
            <button
              type="submit"
              className={`mt-1 w-full bg-gray-900 px-6 py-3 text-sm font-bold uppercase tracking-wide text-white transition-none hover:bg-black sm:mt-0 sm:w-auto sm:shrink-0 ${
                loading ? "cursor-not-allowed opacity-75" : ""
              }`}
              disabled={loading} // Disable button while loading
            >
              {loading ? "Signing Up..." : "Sign Up"}
            </button>
          </div>
        </form>

        {/* Display success or error messages */}
        {message && (
          <p
            className={`mt-4 text-sm ${
              message.includes("Thank you") ? "text-green-500" : "text-red-500"
            }`}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default SidebarSubscribe;
